import "@/App.css";
import CaprioChateau from "@/components/CaprioChateau";
import { AdminProvider } from "@/contexts/AdminContext";

function App() {
    return (
        <div className="App">
            <AdminProvider>
                <CaprioChateau />
            </AdminProvider>
        </div>
    );
}

export default App;
